export default "__VITE_ASSET__4d6c93cd__"